import React from 'react';

import { Tooltip, Typography } from '@mui/material';

import { emptyPredictionText, emptyPredictionTooltip } from './emptyPredictionText';
import { CommandDeparture } from './types';

export default function EmptyPrediction({ departure }: { departure: CommandDeparture }) {
  const text = emptyPredictionText(departure);
  if (!text) return null;
  return (
    <Tooltip title={emptyPredictionTooltip}>
      <Typography variant="caption" display="block" tabIndex={0} data-testid="empty-booking-chance">
        {text}
      </Typography>
    </Tooltip>
  );
}
